/* eslint-disable arrow-body-style */
/* eslint-disable no-console */

import { useRouter } from '@abyss/web/hooks/useRouter';
import { useEffect, useRef } from 'react';
import { routeObserver } from './routeObserver';

export const useRouteObserver = () => {
  const pathname = useRef('==');
  const { getRouteParams, getSearchParams, getLocation } = useRouter();
  const routeParams = getRouteParams() as Record<string, string>;
  const searchParams = getSearchParams()[0];
  const location = getLocation() as Location | null;

  useEffect(() => {
    if (pathname.current === window.location.pathname) {
      return;
    }

    routeObserver.routeChanged({
      pathname: window.location.pathname,
      routeParams,
      searchParams,
      location,
    });

    pathname.current = window.location.pathname;
  }, [getRouteParams, getSearchParams, getLocation]);
};
